import { EnumUtils } from "Global/Base/Utils/EnumUtils";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { ControlParams } from "./ControlInterfaces";
import { ControlWithBackground } from "./ControlWithBackground";

/** Úroveň zobrazovaného popisku */
export enum HeadingLevel {
    default = "default",
    heading1 = "heading1",
    heading2 = "heading2",
    heading3 = "heading3",
    heading4 = "heading4",
    heading5 = "heading5",
    heading6 = "heading6",
}

export class Label extends ControlWithBackground {
    protected _headingLevel: HeadingLevel = HeadingLevel.default;
    public innerElement: HTMLLabelElement;

    /** Úroveň zobrazovaného popisku */
    public get headingLevel(): HeadingLevel {
        return this._headingLevel;
    }

    public set headingLevel(value: HeadingLevel) {
        //odstraní starý css styl
        this.innerElement?.classList.remove(this._getClassByLevel(this._headingLevel));
        this._headingLevel = value;
        //přidá nový css styl
        this.innerElement?.classList.add(this._getClassByLevel(this._headingLevel));
    }

    //#region Constructors
    constructor(params: ControlParams) {
        super(params);

        const locKey = this.getDataAttr("captionLocKey");
        if (locKey) {
            this.innerElement = document.createElement("label");
            Localization.addLocData(this.innerElement, locKey, Localization.TEXT_CONTENT, "title");
            this.element.appendChild(this.innerElement);
        }
        this.headingLevel = EnumUtils.getEnumValueFromName(HeadingLevel, this.getDataAttr("headingLevel"), false);
    }
    //#endregion Constructors

    protected _getClassByLevel(headingLevel: HeadingLevel): string {
        switch (headingLevel) {
            case HeadingLevel.heading1: return "h1";
            case HeadingLevel.heading2: return "h2";
            case HeadingLevel.heading3: return "h3";
            case HeadingLevel.heading4: return "h4";
            case HeadingLevel.heading5: return "h5";
            case HeadingLevel.heading6: return "h6";
            default:
                return "Caption";
        }
    }
}
